import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["captionSide"];
var StyledCaption = styled.caption.withConfig({
  displayName: "Caption__StyledCaption",
  componentId: "sc-rtfr07-0"
})(function (_ref) {
  var $captionSide = _ref.$captionSide;
  return css(["caption-side:", ";"], $captionSide);
});
var Caption = /*#__PURE__*/forwardRef(function Caption(_ref2, ref) {
  var _ref2$captionSide = _ref2.captionSide,
    captionSide = _ref2$captionSide === void 0 ? 'top' : _ref2$captionSide,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/jsx(StyledCaption, _objectSpread(_objectSpread({
    $captionSide: captionSide
  }, props), {}, {
    ref: ref
  }));
});

export { Caption };
